import { render, staticRenderFns } from "./PurchaseOptionLegals.vue?vue&type=template&id=7f1a899a&scoped=true&"
import script from "./PurchaseOptionLegals.vue?vue&type=script&lang=js&"
export * from "./PurchaseOptionLegals.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOptionLegals.vue?vue&type=style&index=0&id=7f1a899a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1a899a",
  null
  
)

component.options.__file = "PurchaseOptionLegals.vue"
export default component.exports